import Vue from 'vue'
import router from '@/router'
import request from '@/helpers/request'
import store from '@/store/index'
import GroupPermissionsBuilder from '@/helpers/group_permissions_builder'
import snack from '@/helpers/snack'

const LIMIT = 30

const notifyNetworkError = () => {
  Vue.notify({
    group: 'hasBottomNavigation',
    title: `Ошибка соединения с сервером.`,
    type: 'error',
    text: 'Попробуйте позже, или обратитесь в техническую поддержку.',
  })
}

export default {
  GET_WORK_POSITIONS: ({ commit, state }, payload) => {
    // if (payload !== undefined && payload.showPreloader) { // Перетирает прелоудер внутри карточки сотрудника
    //   commit('setLoad', true);
    // }
    if (payload?.clearOldData) {
      commit('setWorkPositions', [])
    }

    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`,
      {
        params: payload.params,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setWorkPositions', state.workPositions.concat(data.items))
          commit('setWorkPositionFilters', data.filters)
          // commit('setLoad', false); Перетирает прелоудер внутри карточки сотрудника
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: `Ошибка получения должностей.`,
            type: 'error',
            text: 'Попробуйте позже, или обратитесь в техническую поддержку.',
          })
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
    // commit('setLoad', false);
  },

  GET_WORK_POSITIONS_TYPES: ({ commit, state }, payload) => {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.types}`, true)
      .then(response => {
        const resultArr = []

        for (const key in response.data.data) {
          resultArr.push({
            title: response.data.data[key],
            id: key,
          })
        }

        commit('setWorkPositionsTypes', resultArr)
      })
      .catch(() => {
        notifyNetworkError()
      })
  },

  async GET_WORK_POSITIONS_TYPES_FOR_NEWS(context, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.types}`,
        true,
      )
      const resultArr = []
      for (const key in response.data.data) {
        resultArr.push({
          title: response.data.data[key],
          id: key,
        })
      }
      return resultArr
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
    }
  },

  async FETCH_WORK_POSITIONS(context, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`,
        {
          params: payload,
        },
        true,
      )
      return {
        items: response.data.data.items,
        count: response.data.data.count,
        filters: response.data.data.filters,
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return {
        items: [],
        filters: [],
      }
    }
  },

  GET_WORK_POSITION: ({ commit, state }, workPositionID) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.one.replace('$1', workPositionID)}`,
      {
        params: {
          with: 'permissions',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const workPosition = response.data.data
          commit('setWorkPosition', workPosition)
          commit('setTitle', workPosition.title)
          commit('setLoad', false)
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: `Ошибка при получении должности.`,
            type: 'error',
            text: 'Попробуйте позже, или обратитесь в техническую поддержку.',
          })
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
  },
  GET_WORK_POSITION_WITH_WORK_POSITIONS: async ({ commit, state, rootState }, workPositionID) => {
    await request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.one.replace('$1', workPositionID)}`,
      {
        params: {
          with: 'permissions.permission',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const workPosition = response.data.data

          // Set active group permissions map
          const activeGroupPermissionsMap = {}

          // Set active permissions map
          const activePermissionsMap = {}
          const activePermissionsMapPilkiPro = {}
          _.forEach(workPosition.permissions, permission => {
            if (permission.permission && permission.permission.type === 1) {
              activePermissionsMap[permission.permission_id] = true
            } else if (permission.permission && permission.permission.type === 2) {
              activePermissionsMapPilkiPro[permission.permission_id] = true
            }
          })

          commit('setWorkPosition', workPosition)
          commit('setActivePermissionsMap', activePermissionsMap)
          commit('setActivePermissionsMapPilkiPro', activePermissionsMapPilkiPro)
          commit('setActiveGroupPermissionsMap', activeGroupPermissionsMap)
          commit('setTitle', workPosition.title)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`,
            {
              params: {
                offset: 0,
                limit: LIMIT,
              },
            },
            true,
          )
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setWorkPositions', state.workPositions.concat(data.items))
          commit('setWorkPositionFilters', data.filters)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`,
            {
              params: {
                search: 'type:1',
                searchFields: 'type:=',
              },
            },
            true,
          )
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          const permissions = new GroupPermissionsBuilder().build(data.items)
          const activeIds = Object.keys(rootState.permissions.activePermissionsMap).map(x => parseInt(x))
          const activeGroupPermissionsMap = {}

          for (let i = 0; i < permissions.length; i++) {
            const permission = permissions[i]
            const permissionIds = permission.permissions.map(x => parseInt(x.id))
            if (!permissionIds.some(x => !activeIds.includes(x))) {
              activeGroupPermissionsMap[permission.title] = true
            }
          }

          commit('setActiveGroupPermissionsMap', activeGroupPermissionsMap)
          commit('setGroupPermissions', permissions)
          commit('setLoad', false)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`,
            {
              params: {
                search: 'type:2',
                searchFields: 'type:=',
              },
            },
            true,
          )
        }
      })
      .then(response => {
        const data = response.data.data
        const permissions = new GroupPermissionsBuilder().build(data.items)
        const activeIds = Object.keys(rootState.permissions.activePermissionsMapPilkiPro).map(x => parseInt(x))
        const activeGroupPermissionsMapPilkiPro = {}

        permissions.forEach((item, i) => {
          const permission = permissions[i]
          const permissionIds = permission.permissions.map(x => parseInt(x.id))
          if (!permissionIds.some(x => !activeIds.includes(x))) {
            activeGroupPermissionsMapPilkiPro[permission.title] = true
          }
        })

        commit('setGroupPermissionsPilkiPro', permissions)
        commit('setActiveGroupPermissionsMapPilkiPro', activeGroupPermissionsMapPilkiPro)
      })
      .catch(e => {
        notifyNetworkError()
      })
  },
  UPDATE_WORK_POSITION: ({ commit, state }) => {
    commit('setLoad', true)

    const activePermissions = []
    const keys = Object.keys(store.getters.activePermissionsMap)
    _.forEach(keys, key => {
      if (store.getters.activePermissionsMap[key]) {
        activePermissions.push(key)
      }
    })

    const keysPilkiPro = Object.keys(store.getters.activePermissionsMapPilkiPro)
    _.forEach(keysPilkiPro, key => {
      if (store.getters.activePermissionsMapPilkiPro[key]) {
        activePermissions.push(key)
      }
    })

    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.one.replace('$1', state.workPosition.id)}`,
      {
        title: state.workPosition.title,
        with_services: +state.workPosition.with_services,
        with_schedule: +state.workPosition.with_schedule,
        permissions: activePermissions,
        salary_base: state.workPosition.salary_base,
        type_position: state.workPosition.type_position,
        company_id: state.workPosition.company_id,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          commit('changeWorkPosition', { key: state.workPosition.id, value: state.workPosition })
          commit('setTitle', state.workPosition.title)
          commit('setLoad', false)
          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: Vue.config.localization.ru.savedErrorMessage,
            type: 'error',
            text: 'Ошибка при изменении должности. Обратитесь в техническую поддержку.',
          })
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
    commit('setLoad', false)
  },
  CREATE_WORK_POSITION: ({ commit, state }) => {
    commit('setLoad', true)

    const activePermissions = []
    const keys = Object.keys(store.getters.activePermissionsMap)
    _.forEach(keys, key => {
      if (store.getters.activePermissionsMap[key]) {
        activePermissions.push(key)
      }
    })

    const withServices = state.workPosition.with_services ? +state.workPosition.with_services : 0
    const withSchedule = state.workPosition.with_schedule ? +state.workPosition.with_schedule : 0

    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`,
      {
        title: state.workPosition.title,
        company_id: state.workPosition.company_id,
        with_services: withServices,
        with_schedule: withSchedule,
        permissions: activePermissions,
        salary_base: state.workPosition.salary_base,
        type_position: state.workPosition.type_position,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setWorkPositionField', { key: 'id', value: data.id })
          commit('setTitle', data.title)
          commit('unshiftWorkPositions', { ...state.workPosition })
          router.push({ path: Vue.config.modules.crm.route.workPositions.one.replace('$1', data.id) })
          commit('setLoad', false)
          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: Vue.config.localization.ru.savedErrorMessage,
            type: 'error',
            text: 'Ошибка при создании должности. Обратитесь в техническую поддержку.',
          })
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
    commit('setLoad', false)
  },
  DELETE_WORK_POSITION: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.one.replace('$1', state.workPosition.id)}`,
      {},
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          commit('deleteWorkPosition', state.workPosition.id)
          const positionsLength = state.workPositions.length

          if (positionsLength != 0) {
            commit('setWorkPosition', state.workPositions[0])
            commit('setWorkPositionField', { key: 'id', value: state.workPositions[0].id })
            commit('setTitle', state.workPositions[0].title)

            commit('setWorkPositionErrors', null)
            commit('setLoad', false)

            router.push({ path: Vue.config.modules.crm.route.workPosition.one.replace('$1', 1) })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.workPositions.all })
          }
        } else {
          commit('setWorkPositionErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
    commit('setLoad', false)
  },
  GET_NEW_WORK_POSITIONS_DATA: ({ commit, state }) => {
    commit('setLoad', true)

    // Get work positions
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.workPositions.all}`,
      {
        params: {
          offset: 0,
          limit: LIMIT,
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setWorkPositions', state.workPositions.concat(data.items))

          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setGroupPermissions', new GroupPermissionsBuilder().build(data.items))
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
    return true
    // commit('setLoad', false);
  },
}
